import { Dispatch, FC, SetStateAction, MouseEvent, MutableRefObject } from 'react';
import { dashboardApiV3 } from '#api';
import { NotificationV3 } from '#types';
import { useAppContext, useSafeState } from '#hooks';

interface ConfirmationSendNotificationProps {
    setIsConfirmationOpen: Dispatch<SetStateAction<boolean>>;
    notification: NotificationV3;
}

export const ConfirmationSendNotificationV3: FC<ConfirmationSendNotificationProps> = ({ setIsConfirmationOpen, notification }) => {

    const { setApiStatus } = useAppContext();
    const [isLoading, setIsLoading] = useSafeState<boolean>(false)

    const handleCancel = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsConfirmationOpen(false);
    }

    //TODO: adjust imageUrl
    const handleSubmit = async (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const res = await dashboardApiV3.sendNotification(notification)
            setApiStatus({ code: res.status, message: 'Notification sent' })
            setIsConfirmationOpen(false)
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    // const highlightCodes = (text: string): JSX.Element => {
    //     const regexString = notificationCodes.map((code) => code.code.slice(1, -1)).join('|');
    //     const regex = new RegExp(`({(?:${regexString})})`, 'g');
    //     const parts = text.split(regex);
    //     return (
    //         <>
    //             {
    //                 parts.map(
    //                     (part, i) => {
    //                         const className = regex.test(part) ? 'highlight-accent' : '';
    //                         return <span className={className} key={i} >{part}</span>
    //                     }
    //                 )
    //             }
    //         </>
    //     );
    // };

    return <div className="main-dashboard-container pd-m mt-s line-height">
        <p className='bold'>Please Check And Submit The Notification To Send</p>
        {
            notification.payload?.name && <div className='min-width mt-m'>
                <span className='bold'>Name: </span>
                <p>{notification.payload.name as string}</p>
            </div>
        }
        {
            notification.payload?.promoCode && <div className='min-width mt-s'>
                <span className='bold'>Promocode: </span>
                <span>{notification.payload.promoCode as string}</span>
            </div>
        }
        {
            notification.payload?.discountPercent && notification.payload?.discountPercent !== 0 && <div className='min-width mt-s'>
                <span className='bold'>Discount Percent: </span>
                <span>{notification.payload.discountPercent?.toString() as string}</span>
            </div>
        }
        <div className='min-width mt-s'>
            <span className='bold'>Type: </span>
            <span>{notification.type}</span>
        </div>
        {/* {
            notification.recipients !== RecipientType.INDIVIDUAL && <div className='min-width mt-s'>
                <span className='bold'>Language: </span>
                <span>{notification.lang}</span>
            </div>
        } */}
        {
            isLoading ?
                <div className="lds-hourglass" /> :
                <div className="mt-m four-columns-expand-one-four">
                    <div />
                    <button onClick={handleSubmit} id='notification-confirmation-button' className='pd-s mr-m bold'>SUBMIT</button>
                    <button onClick={handleCancel} id='notification-confirmation-button' className='pd-s bold'>CANCEL</button>
                    <div />
                </div>
        }
    </div>
}
